<dl class="timeline-preview">
  @for (entry of entries(); track entry.label; let index = $index) {
    <dt [style.grid-row]="index + 1">{{ entry.label }}</dt>
    <dd [style.grid-row]="index + 1">
      @if (entry.icon) {
        <span class="material-symbols-outlined">{{ entry.icon }}</span>
      }
      <span class="timeline-preview__value" [title]="entry.value">{{ entry.value }}</span>
    </dd>
  }
</dl>
